import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import LocationIcon from "../../../assets/discovery/location-icon.png";
import backButtonIcon from "../../../assets/discovery/location-back.png";
import * as ROUTES from "../../../constants/routes";
import { MyAppSettingController } from "@njoy/controller";

interface Props {
  // navMenu: any;
  // currentPage: number;
  pageTitle: string;
}

// class C extends React.PureComponent<Props> {
const C: React.FC<Props> = ({ pageTitle }) => {
  useEffect(() => {
    document.title = pageTitle;
    return () => {
      document.title = "Njoy"; // or your default
    };
  }, [pageTitle]);

  return (
    <MyAppSettingController>
      {({data, loading}) => (
        <div className="flex flex-col pb-[1rem]">
          <div className="flex justify-between items-center px-[1rem]  mt-12 ">
            <div className="w-[35px] h-[35px]"></div>
            <p className="text-[20px] font-extrabold text-center mx-auto text-white">
              {pageTitle}
            </p>
            <div className="w-[35px] h-[35px]"></div>
          </div>
          <Link to={ROUTES.APP_SETTINGS}>
            <div className="bg-white/10 mx-auto flex justify-center px-4 items-center gap-2 h-6 w-fit rounded-md cursor-pointer">
              <img src={LocationIcon} alt="location" width={13} height={13} />
              {
                loading ? (
                <p className="text-[11px] text-[#9fafb5] text-center">
                  Loading...
                </p>
                ) : (
                  <p className="text-[11px] text-[#ffffff] text-center">
                    {data?.myAppSetting?.location?.city}
                  </p>
                )
              }
              <img src={backButtonIcon} alt="arrow" width={8} height={8} />
            </div>
          </Link>
        </div>
      )}
    </MyAppSettingController>
  );
};

export const HeaderPlain = C;
